<template>
	<section :class="[componentClass, colorMode, {visible: visible, ready: ready}]">
		<div id="article-header-image-wrapper" :class="[{ hidden: hidden }]">
			<img 
				:src="data.image.src" 
				:srcset="data.image.srcset" 
				:alt="data.image.alt" />
		</div>
		<Tooltip 
			v-if="data.image_credit" 
			:text="data.image_credit" />
		<div class="title-wrapper">
			<div class="row">
				<div class="small-12 columns">
					<h1 v-html="sanitizedTitle"></h1>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import DOMPurify from 'dompurify';
import BaseBlock from './Base';
import Tooltip from './parts/Tooltip';
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'article-header',
			hidden: false,
		}
	},
	computed: {
		sanitizedTitle() {
			return DOMPurify.sanitize(this.data.title);
		}
	},
	methods: {
		hideShowHeader() {
			this.hidden = (window.pageYOffset > 1200);
		}
	},
	mounted() {
		window.addEventListener('resize', this.hideShowHeader);
		window.addEventListener('scroll', this.hideShowHeader);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.hideShowHeader);
		window.removeEventListener('scroll', this.hideShowHeader);
	},
	components: {
		Tooltip
	}
}
</script>

<style lang="scss">
  @import "../../styles/scss/component/article-header";
</style>